module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Produtos Cadastrados "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(this.status(_vm.filial)))])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.produtos), function(produto, indice) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(produto.Id))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (produto.Nome),
        expression: "produto.Nome"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "min": "0"
      },
      domProps: {
        "value": (produto.Nome)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(produto, "Nome", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (produto.QuantidadePorPessoa),
        expression: "produto.QuantidadePorPessoa"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (produto.QuantidadePorPessoa)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(produto, "QuantidadePorPessoa", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (produto.QuantidadeEmEstoque),
        expression: "produto.QuantidadeEmEstoque"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (produto.QuantidadeEmEstoque)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(produto, "QuantidadeEmEstoque", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "title": "Atualizar"
      },
      on: {
        "click": function($event) {
          return _vm.atualizar(indice)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button",
        "title": "Excluir Produto"
      },
      on: {
        "click": function($event) {
          return _vm.deletar(produto.Id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), _vm._v(" "), (_vm.produtos.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Não encontramos nenhum produto cadastro nessa Unidade")])]) : _vm._e()], 2), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('IncluirProduto')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Id")]), _vm._v(" "), _c('td', [_vm._v("Produto")]), _vm._v(" "), _c('td', [_vm._v("Quantidade Por Pessoa ")]), _vm._v(" "), _c('td', [_vm._v("Quantidade Em Estoque")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "5"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "title": "Incluir Produto",
      "data-toggle": "modal",
      "data-target": "#modalIncluirProduto"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53196352"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/estoque/ProdutosCadastrados.vue
// module id = 291
// module chunks = 1